<template>
  <div id="listWidget" class="mb-4" style="padding-bottom: 5rem;">
    <div>
      <!-- <h4 class="mb-3">공유</h4> -->
      
      <!-- 공유 안내 -->
      <div class="instruction-card card-item mb-3">
        <div class="instruction-header">
          <i class="fa-solid fa-info-circle me-2 text-primary"></i>
          <span class="instruction-title">공유 안내</span>
        </div>
        <div class="instruction-body">
          <p class="mb-0" style="font-size: 0.85rem; line-height: 1.6; color: #495057;">
            공유 기능을 통해 가족이나 같은 공간을 사용하는 사람들과 영역을 공유할 수 있습니다. 공유된 영역에 대한 제어권을 함께 사용할 수 있습니다.
          </p>
        </div>
      </div>

      <!-- 공유 절차 -->
      <div class="instruction-card card-item mb-3">
        <div class="instruction-header">
          <i class="fa-solid fa-list-ol me-2 text-primary"></i>
          <span class="instruction-title">공유 절차</span>
        </div>
        <div class="instruction-body">
          <div class="instruction-step">
            <div class="step-number">1</div>
            <div class="step-content">
              <span>공유코드를 입력해주세요.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-number">2</div>
            <div class="step-content">
              <span><strong class="text-primary">공유하기 버튼</strong>을 눌러주세요.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-number">3</div>
            <div class="step-content">
              <span>공유 성공 시 상대방이 설정 정보를 받습니다.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 공유코드 입력 카드 -->
      <div class="input-card card-item mb-3">
        <div class="input-card-header">
          <i class="fa-solid fa-key me-2 text-primary"></i>
          <span class="input-card-title">공유코드 입력</span>
        </div>
        <div class="input-card-body">
          <input
            type="text"
            class="form-control form-control-lg"
            placeholder="공유코드를 입력해주세요."
            v-model="shareCode"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6 mb-4" v-if="sharedMembers.length > 0">
        <div class="text-muted fs-12px mb-2"><b>구성원</b></div>
        <Card>
          <div class="list-group list-group-flush">
            <MemberItem
              v-for="(item, index) in sharedMembers"
              :key="index"
              :item="item"
              :handleSharedZonesUpdated="onSharedZonesChanged"
            />
          </div>
        </Card>
      </div>
      <div class="col-xl-6" v-if="shareOwners.length > 0">
        <div class="text-muted fs-12px mb-2"><b>공유자</b></div>
        <Card>
          <div class="list-group list-group-flush">
            <OwnerItem
              v-for="(item, index) in shareOwners"
              :key="index"
              :item="item"
              :handleShareOwnerUpdated="onShareOwnerChanged"
            />
          </div>
        </Card>
      </div>
    </div>
  </div>

  <!-- 공유하기 버튼 (하단 고정) -->
  <div class="action-button-container-fixed">
    <button
      type="button"
      class="btn btn-primary w-100"
      @click="onShareClick"
    >
      <i class="fa-regular fa-share-from-square me-2"></i>
      공유하기
    </button>
  </div>
</template>

<script setup>
import Card from '@/common/template/components/bootstrap/Card.vue';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';
import MemberItem from './components/MemberItem.vue';
import OwnerItem from './components/OwnerItem.vue';
import { ref, getCurrentInstance, onBeforeMount ,onBeforeUnmount, computed } from 'vue';
import { useStore } from 'vuex';
import Axios, { AuthApi } from '@/api';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';

const store = useStore();
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const shareCode = ref('');
const account = computed(() => store.getters['account']);
const zones = computed(() => store.getters['home/getZones']);
const sharedZones = computed(() => zones.value.filter(zone => zone.ownerId != account.value._id));
const sharedMembers = ref([]);
const shareOwners = ref([]);

onBeforeMount(() => {
  emitter.emit('onChangeHeaderSetting',{title:'공유',isShowZone:false,isShowMenu:false,isShowRightHome:false,isShowProfile:false});
  requestMembers();
  const ownerIds = sharedZones.value.map(zone => zone.ownerId);
  requestOwners(ownerIds);
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowZone:true,isShowMenu:true,isShowRightHome:false,isShowProfile:true});
})


const requestShare = async (params) => {
  try {
    const result = await Axios.post(AuthApi.SHARE, params, 'auth');
    if (result.resultCode === '0000') {
      sharedMembers.value.push(result.resultData);
      shareCode.value = "";
      emitter.emit('showPopAlert', {
        description: '공유가 완료되었습니다.',
      });
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '공유하기에 실패했습니다.',
    });
  }
};

const requestMembers = async () => {
  try {
    const result = await Axios.get(AuthApi.MEMBERS, undefined, 'auth');
    if (result.resultCode === '0000') {
      sharedMembers.value = result.resultData;
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '공유 구성원 조회에 실패했습니다.',
    });
  }
};

const requestOwners = async (ids) => {
  try {
    if (ids.length === 0) {
      shareOwners.value = [];
      return;
    }

    console.log(ids);
    const result = await Axios.get(AuthApi.USER, { ids }, 'auth');
    if (result.resultCode === '0000') {
      shareOwners.value = result.resultData;
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '공유자 조회에 실패했습니다.',
    });
  }
};


const onShareClick = () => {
  if (sharedZones.value.length > 0) {
    emitter.emit('showPopAlert', {
      description: '공유받은 사용자는 다른 사용자에게 공유할 수 없습니다.',
    });
    return;
  }
  if (shareCode.value.length === 0) {
    emitter.emit('showPopAlert', {
      description: '공유코드를 입력해주세요.',
    });
    return;
  }
  if (shareCode.value == account.value.shareCode) {
    emitter.emit('showPopAlert', {
      description: '자신의 공유코드는 사용할 수 없습니다.',
    });
    return;
  }
  requestShare({ id: shareCode.value });
};

const onSharedZonesChanged = (params) => {
  requestMembers();
  // const targetIndex = sharedMembers.value.findIndex(
  //   (item) => item._id === params.id,
  // );
  // if (targetIndex >= 0) {
  //   // sharedMembers.value[targetIndex].zones = params.zones;
  //   requestMembers();
  // }
};

const onShareOwnerChanged = async () => {
  await store.dispatch('home/fetchAllZones');
  const ownerIds = sharedZones.value.map(zone => zone.ownerId);
  requestOwners(ownerIds);
}
</script>

<style scoped>
/* instruction-card 스타일 */
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.instruction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: #495057;
}

.step-content strong {
  color: #0d6efd;
  font-weight: 600;
}

/* input-card 스타일 */
.input-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.input-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.input-card-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.input-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.input-card-body {
  padding: 1rem;
}

.input-card-body input {
  font-size: 0.875rem;
}

.input-card-body input::placeholder {
  font-size: 0.875rem;
}

/* action-button-container-fixed 스타일 */
.action-button-container-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background-color: transparent;
  border-top: none;
  box-shadow: none;
  z-index: 1000;
}

/* PC(사이드바 존재)에서는 콘텐츠 영역 폭에 맞춘다 */
@media (min-width: 992px) {
  .action-button-container-fixed {
    left: 240px;
    right: 0;
  }

  /* 사이드바가 접힌(미니파이) 경우 */
  :global(.app-sidebar-minified) .action-button-container-fixed {
    left: 65px;
  }

  /* 사이드바 숨김(콘텐츠 full width) 경우 */
  :global(.app-content-full-width) .action-button-container-fixed,
  :global(.app-without-sidebar) .action-button-container-fixed {
    left: 0;
  }
}

.action-button-container-fixed .btn {
  padding: 0.75rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-button-container-fixed .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.action-button-container-fixed .btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 모바일 반응형 간격 조정 */
@media (max-width: 768px) {
  #listWidget {
    margin-bottom: 1rem;
    padding-bottom: 5.5rem;
  }

  .instruction-card,
  .input-card {
    margin-bottom: 1rem;
  }

  .action-button-container-fixed {
    padding: 0.875rem;
  }

  .action-button-container-fixed .btn {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
  }
}
</style>
